import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import AddRakePointForm from './AddRakePointForm';

const AddRakePointDialog = ({ open, onOpenChange, onCreateRakePoint }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (payload) => {
    setSubmitting(true);
    try {
      await onCreateRakePoint(payload);
      onOpenChange(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">Add New Rake Point</DialogTitle>
        </DialogHeader>
        <AddRakePointForm
          onSubmit={handleSubmit}
          onCancel={() => onOpenChange(false)}
          submitting={submitting}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddRakePointDialog;
